import styled from '@emotion/styled';
import { breakpoints } from '~/theme';
import { getClampFullRange } from '~/theme/utils/getClampValue';
import { ifProp } from 'styled-tools';

export const StyledProductGrid = styled.div<{
    gridLayout?: 'full' | 'with-menu';
    marketingContent?: boolean;
}>(
    ({ theme, gridLayout = 'with-menu' }) => ({
        display: 'grid',
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        padding: `0 ${getClampFullRange(theme.spacesRaw[2], theme.spacesRaw[5])}`,
        margin: `${theme.spaces[4]} calc(${theme.gridConfig.gutter} * -1)`,
        columnGap: getClampFullRange(theme.spacesRaw[2], theme.spacesRaw[5]),
        rowGap: getClampFullRange(theme.spacesRaw[3], theme.spacesRaw[5]),
        position: 'relative',
        zIndex: 0,
        '&:empty': {
            minHeight: '100vh',
        },
        [breakpoints.sm]: {
            gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
        },
        [breakpoints.md]: {
            margin: 0,
            padding: 0,
            gridTemplateColumns: `repeat(${gridLayout === 'full' ? '4' : '3'}, minmax(0, 1fr))`,
            columnGap: getClampFullRange(theme.spacesRaw[2], theme.spacesRaw[3]),
            rowGap: getClampFullRange(theme.spacesRaw[2], theme.spacesRaw[4]),
        },
        [breakpoints.xl]: {
            gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
        },
    }),
    ifProp('marketingContent', () => ({
        gridAutoFlow: 'dense',
        gridAutoRows: '1fr',
    }))
);

export const StyledProductsCounterWrapper = styled.div(() => ({
    [breakpoints.md]: {
        display: 'none',
    },
}));
